<template>
  <div>
    <div>
      <h3 class="title-color">Installation Details</h3>
    </div>
    <div class="e-card-separator"></div>
    <ejs-grid
      ref="installationDetailsGrid"
      v-if="applicationWorkLists"
      :dataSource="applicationWorkLists"
      allowResizing="true"
      allowTextWrap="true"
    >
      <e-columns>
        <e-column
          field="question"
          headerText="Please confirm the following work to be completed"
          width="50%"
        />
        <e-column headerText="Choose One" :template="radioColumnTemplate" />
        <e-column
          headerText="Additional Information"
          :template="textBoxColumnTemplate"
        />
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import radioButtonTemplateVue from './installation details templates/radio-button-template.vue';
import textboxTemplateVue from './installation details templates/textbox-template.vue';

export default {
  name: 'InstallationDetails',
  data() {
    return {
      radioColumnTemplate: () => ({
        template: radioButtonTemplateVue,
      }),
      textBoxColumnTemplate: () => ({
        template: textboxTemplateVue,
      }),
    };
  },
  computed: {
    ...mapGetters({
      applicationWorkLists: 'applicationWorkLists',
    }),
  },
};
</script>
